<template>
  <div id="JudgmentDoctorSelectModal">
    <div class="modal-card" style="width:900px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">判定医選択</p>
      </header>
      <section class="modal-card-body">
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>医療機関名</th><td><input type="text" v-model="searchConditions.hospitalName"/></td>
              <th>判定医名</th><td><input type="text" v-model="searchConditions.doctorName"/></td>
            </tr>
          </table>
          <div class="searchButton-area" style="margin-bottom:10px;text-align: center;">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area">
          <b-table
            v-if="data.length > 0"
            id="customerSelectTable"
            :data="data"
            paginated
            per-page="20"
            pagination-position="both"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="customerId" label="" width="20" centered>
                <b-radio class="customRadio" name="radioItem" v-model="selectedItem" :native-value="props.row"></b-radio>
              </b-table-column>
              <b-table-column field="customerCode" label="得意先コード" width="100" centered>{{props.row.customerCode }}</b-table-column>
              <b-table-column field="doctorName" label="医師名" width="200" >{{props.row.doctorName}}</b-table-column>
              <b-table-column field="hospitalName" label="医療機関名" width="250" >{{props.row.hospitalName}}</b-table-column>
              <b-table-column field="address" label="住所" width="400" >{{props.row.address}}</b-table-column>
            </template>
          </b-table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="save" :disabled="!selectedItem">決定</button>
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
export default {
  name: "JudgmentDoctorSelectModal",
  props: {
    selectRole:{type:[Array], default: () => [], },
  },
  methods: {
    save: function() {
      this.$emit('select', this.selectedItem);
      this.$parent.close();
    },
    doSearch: function() {
      this.selectedItem = null;
      let _this = this;
      let obj = JSON.parse(JSON.stringify(this.searchConditions));
      // Web Api Call
      this.apiCall(
        function(client){
          // TODO 判定医（selectRole）を検索条件に追加
          return client.apis.apiCommon.getJudgmentDoctorListPOST({
            body:obj
          });
        },
        function(result) {
          // 検索結果取得
          _this.data = result.obj
        },
        function(result) {
          // エラーメッセージ表示
          _this.showErrorMessage(result);
        },
      );
    }
  },
  data() {
    return {
      role: role,
      data: [],
      searchConditions:{
        hospitalName:"",
        doctorName:""
      },
      selectedItem:'',
    };
  },
  filters: {},
  components: {},
  mounted: function () {},
};
</script>
<style lang="scss" scoped>
.customRadio {
  width:10px;
}
.result-area {
  height: 450px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/JudgmentDoctorSelectModal.vue